import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Panel } from "@/components/PageHeader";
import { api, errMsg, euro, SOCIO_CATEGORIES, slug } from "@/lib/api";

const QuotaRow = ({ anno, categoria, quota, onSaved }) => {
  const [val, setVal] = useState("");
  useEffect(() => {
    setVal(quota ? String(quota.importo) : "");
  }, [quota]);
  const save = async () => {
    try {
      await api.put("/admin/quote", { anno: Number(anno), categoria_socio: categoria, importo: Number(val) });
      toast.success(`Quota ${anno} salvata: ${categoria}`);
      onSaved();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="grid grid-cols-1 sm:grid-cols-[1fr_160px_auto] gap-3 items-center py-3 border-b last:border-0">
      <div>
        <div className="font-medium">{categoria}</div>
        <div className="text-xs text-muted-foreground">{quota ? `Attuale: ${euro(quota.importo)}` : "Non definita"}</div>
      </div>
      <Input type="number" min="0" step="0.01" placeholder="€" value={val} onChange={(e) => setVal(e.target.value)} data-testid={`quota-input-${slug(categoria)}`} />
      <Button onClick={save} disabled={val === ""} className="bg-emerald-600 hover:bg-emerald-700" data-testid={`quota-save-button-${slug(categoria)}`}>Salva</Button>
    </div>
  );
};

export const QuoteAdmin = () => {
  const [anno, setAnno] = useState(String(new Date().getFullYear()));
  const [quote, setQuote] = useState([]);
  const load = useCallback(() => {
    if (!/^\d{4}$/.test(anno)) return;
    api.get("/quote", { params: { anno } }).then((r) => setQuote(r.data));
  }, [anno]);
  useEffect(() => {
    load();
  }, [load]);

  return (
    <Panel className="max-w-3xl">
      <h2 className="font-heading text-2xl uppercase mb-1">Quote associative</h2>
      <p className="text-sm text-muted-foreground mb-6">Valide dal 1 gennaio al 31 dicembre dell'anno indicato.</p>
      <div className="w-40 mb-4">
        <Label>Anno</Label>
        <Input type="number" value={anno} onChange={(e) => setAnno(e.target.value)} data-testid="quote-year-input" />
      </div>
      {SOCIO_CATEGORIES.map((c) => (
        <QuotaRow key={c} anno={anno} categoria={c} quota={quote.find((q) => q.categoria_socio === c)} onSaved={load} />
      ))}
    </Panel>
  );
};
